export default {
  GET_INSTRUCTORS: '@@instructors/GET'
};
